import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Menu from "../components/Menu";
import BarSuperior from "../components/SuperiorBar";
import styled from "styled-components";
import Pacientes from "./DashPaciente/Pacientes";
import Protocolos from "./DashProtocolos/Protocolos";
import ExercisesInProtocol from "./DashProtocolos/ExercisesInProtocol/ExercisesInProtocol";
import MinhaConta from "./MenueConta/MinhaConta";
import Perfil from "./MenueConta/Perfil";
import MeuPlano from "./MenueConta/MeuPlano";
import ListagemAval from "./DashPaciente/ListagemAval";
import Pagamentos from "./MenueConta/Pagamentos";
import PersonalizarRelatorio from "./MenueConta/PersonalizarRelatorio";
import ExportarDados from "./MenueConta/ExportarDados";
import Etiquetas from "./MenueConta/Etiquetas";
import Configuracoes from "./MenueConta/Configuracoes";
import GerenciadorExcluidos from "./MenueConta/GerenciadorExcluidos";
import Exercicios from "./DashProtocolos/Exercicios";
import Paciente from "./Paciente";
import DetailInfoPatient from "./Paciente/InformacoesPaciente";
import ProtocolsInPatient from "./Paciente/Protocolos/Protocolos";
import ExercisesForExecution from "./Paciente/Protocolos/ExercisesInProtocol";
import ExercisesInPatient from "./Paciente/Exercicios/Exercicios";
import Avaliacao from "./Execucao/Protocolo";
import Anotacoes from "./Paciente/Anotacoes/ListagemAnotacoes";
import CriarAnotacao from "./Paciente/Anotacoes/CriarAnotacao";
import Anotacao from "./Paciente/Anotacoes/Anotacao";
import EditarAnotacao from "./Paciente/Anotacoes/EditarAnotacao";
import Assimetria from "./Relatorios/Assimetria";
import HistoricoAssimetria from "./Relatorios/Assimetria/EvolucaoAssimetria/HistoricoAssimetria/HistoricoAssimetria";
import Anamnese from "./Paciente/Anamnese/Anamnese";
import TiposAnamnese from "./Paciente/Anamnese/TiposAnamnese";
import QuestionariosAntigos from "./Paciente/Anamnese/QuestionariosAntigos";
import QuestionarioNovo from "./Paciente/Anamnese/QuestionarioNovo";
import RelatorioAnamnese from "./Relatorios/RelatorioAnamnese/RelatorioAnamnese";
import ListaHistoricoAnamnese from "./Relatorios/RelatorioAnamnese/ListaHistoricoAnamnese";
import HistoricoAnamnese from "./Relatorios/RelatorioAnamnese/HistoricoAnamnese";
import QualidadeDeVida from "./Relatorios/QualidadeDeVida/QualidadeDevida";
import ListaHistoricoQualidadeVida from "./Relatorios/QualidadeDeVida/ListaHistoricoQualidadeVida";
import Evolucao from "./Relatorios/Evolucao";
import ForcaTempo from "./Relatorios/ForcaTempo";
import EmissaoRelatorios from "./Relatorios/EmissaoRelatorios";
import SelecaoExercicios from "./Relatorios/EmissaoRelatorios/SelecaoExercicios";
import SelecaoPeriodo from "./Relatorios/EmissaoRelatorios/SelecaoPeriodo";
import Desequilibrio from "./Relatorios/Desequilibrio";
import MetodoPagamento from "./MenueConta/MetodoPagamento";
import EditTagPage from "./EditTag";
import MapaDor from "./Paciente/MapaDor";
import PreReportEva from "./Paciente/PreReportEva";
import ReportPainMap from "./Relatorios/RelatorioMapaDorEva";
import HistoricoRelatorioEva from "./Relatorios/RelatorioMapaDorEva/HistoricoRelatorioMapaDorEva";
import DetailHistoricPainMap from "./Relatorios/RelatorioMapaDorEva/DetalheHistorico";
import QuestionarioFibromialgia from "./Paciente/PreReportEva/QuestionarioFibromialgia";
import ReportPalmar from "./Relatorios/PalmarGrip";
import DashDynaLabs from "./DashDyanalabs/Dashboard";
import PagamentosExternal from "./MenueConta/PagamentosExternal";
import { useDataSubscription } from "../hooks/useDataSubscription";
import { AppActions } from "../store/ducks/app";
import { sendErrorSentryOrLocalHost } from "../utils/funcs";
import moment from "moment";
import { TypesErrorRequest } from "../utils/types";
import { ConfigsActions } from "../store/ducks/configs";
import { DashBoardActions } from "../store/ducks/dashboard";
import OperationalDashboard from "./OperationalDashboard";

const Dashboard: React.FC = () => {
	const dispatch = useDispatch();
	const openMenu = useSelector((state: any) => state.app.openMenu);
	const current_page: string = useSelector(
		(state: any) => state.dashboard.current_page
	);
	const dataReport = useSelector(
		(state: any) => state.avaliation.data_report_EVA
	);

	const {
		selectedService,
		isPlanExpired,
		registredUnifiedReport,
		hasServiceWorklab,
		hasOperationalDashboardAccess,
	} = useDataSubscription("uni_complete_report");

	const showContractPlansModal = useSelector(
		(state: any) => state.avaliation.showContractPlansModal
	);

	const user_logado = useSelector((state: any) => state.auth.user);
	const reportLimit = Number(selectedService?.value);
	const isLimitReached =
		selectedService?.value !== "unlimited" &&
		selectedService?.value !== undefined &&
		registredUnifiedReport >= reportLimit;

	const getContractPlanData = useCallback(async () => {
		if (!user_logado?.token) {
			return;
		}

		const today = moment().format("YYYY-MM-DD HH:mm:ss");

		try {
			const response = await fetch(
				`${process.env.REACT_APP_BASE_URL_V7}syncs/termos_assinados_plano`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${user_logado.token}`,
					},
					body: JSON.stringify({
						TOKEN: user_logado.token,
					}),
				}
			);

			const data = await response.json();

			if (data?.status === TypesErrorRequest.FAIL) {
				return;
			}

			const acceptedTerms = Array.isArray(data?.termos_assinados)
				? data.termos_assinados
				: [];
			const visualizations = Array.isArray(data?.visualizacao)
				? data.visualizacao
				: [];

			const hasAcceptedCurrentTerm = acceptedTerms.some(
				(item: any) =>
					item?.TERMO_VERSAO === "1" && item?.TERMO_RESPOSTA === "S"
			);

			if (hasAcceptedCurrentTerm) {
				return;
			}

			const alreadyShownToday = visualizations.some((item: any) =>
				moment(item.TERMO_VISUALIZADO).isSame(moment(), "day")
			);

			if (!alreadyShownToday) {
				dispatch(
					AppActions.set_can_close_modal_accept_terms(visualizations.length < 3)
				);
				dispatch(AppActions.set_open_modal_accept_terms(true));
				dispatch(
					ConfigsActions.set_modal_visualization({
						txTipo: "TERMO_ACEITE",
						txCategoria: "1",
						txDataHora: today,
					})
				);
			}
		} catch (e) {
			sendErrorSentryOrLocalHost(e, {
				message: "Erro ao buscar termos do plano - getContractPlanData",
				tags: {
					endpoint: "syncs/termos_assinados_plano",
					file: "src/components/Modais/ModalAcceptTerms/index.tsx",
				},
			});
		}
	}, [dispatch, user_logado?.token]);

	useEffect(() => {
		if (showContractPlansModal) {
			getContractPlanData();
		}
	}, [getContractPlanData, showContractPlansModal]);

	useEffect(() => {
		if (isLimitReached || isPlanExpired) {
			dispatch(AppActions.set_open_modal_upgrade_subscription(true));
		}
	}, [dispatch, isLimitReached, isPlanExpired, selectedService]);

	useEffect(() => {
		if (hasServiceWorklab && current_page === "painel_operacional") {
			dispatch(DashBoardActions.set_current_page("pacientes"));
			dispatch(AppActions.set_option_menu(false, "Início"));
		}
	}, [current_page, dispatch, hasServiceWorklab]);

	const pages_components: any = {
		pacientes: <Pacientes />,
		protocolos: <Protocolos />,
		exercicios: <Exercicios />,
		exercises_in_protocol: <ExercisesInProtocol />,
		minha_conta: <MinhaConta />,
		perfil: <Perfil />,
		meu_plano: <MeuPlano />,
		evaluator: <ListagemAval />,
		pagamentos: <Pagamentos />,
		personalizar_relatorio: <PersonalizarRelatorio />,
		exportarDados: <ExportarDados />,
		etiquetas: <Etiquetas />,
		configuracoes: <Configuracoes />,
		gerenciador_excluidos: <GerenciadorExcluidos />,
		perfil_paciente: <Paciente />,
		informacoes_paciente: <DetailInfoPatient />,
		protocols_in_patient: <ProtocolsInPatient />,
		exercises_in_patient: <ExercisesInPatient />,
		exercises_for_execution: <ExercisesForExecution />,
		execucao: <Avaliacao />,
		listagem_anotacoes: <Anotacoes />,
		anotacao: <Anotacao />,
		criar_anotacao: <CriarAnotacao />,
		editar_anotacao: <EditarAnotacao />,
		assimetria: <Assimetria />,
		historico_assimetria: <HistoricoAssimetria />,
		anamnese: <Anamnese />,
		tipos_anamnese: <TiposAnamnese />,
		questionarios_antigos: <QuestionariosAntigos />,
		questionario_novo: <QuestionarioNovo />,
		relatorio_anamnese: <RelatorioAnamnese />,
		lista_historico_anamnese: <ListaHistoricoAnamnese />,
		historico_anamnese: <HistoricoAnamnese />,
		relatorio_qualidade_vida: <QualidadeDeVida />,
		lista_historico_qualidade_vida: <ListaHistoricoQualidadeVida />,
		relatorio_evolucao: <Evolucao />,
		relatorio_forca_tempo: <ForcaTempo />,
		emissao_relatorios: <EmissaoRelatorios />,
		selecao_exercicios: <SelecaoExercicios />,
		selecao_periodo: <SelecaoPeriodo />,
		desequilibrio_muscular: <Desequilibrio />,
		adicionar_pagamento: <MetodoPagamento />,
		edit_tag: <EditTagPage />,
		mapa_dor: <MapaDor />,
		pre_report_eva: <PreReportEva />,
		relatorio_pain_map: <ReportPainMap dataReport={dataReport} />,
		historic_pain_map: <HistoricoRelatorioEva />,
		detail_historico_relatorio_pain_map: <DetailHistoricPainMap />,
		questionario_fibromialgia: <QuestionarioFibromialgia />,
		relatorio_preensao_palmar: <ReportPalmar />,
		dash_dynalabs: <DashDynaLabs />,
		pagamentos_external: <PagamentosExternal />,
		painel_operacional: hasOperationalDashboardAccess ? (
			<OperationalDashboard />
		) : (
			<Pacientes />
		),
	};

	return (
		<Body className={`overflow-x-hidden`}>
			<BarSuperior />
			<ContentApp className={`overflow-x-hidden`}>
				<Menu />
				{openMenu && <Overlay isVisible={openMenu} />}
				{pages_components[current_page]}
			</ContentApp>
		</Body>
	);
};

const Body = styled.div`
	display: flex;
	color: rgba(140, 142, 134, 0, 8);
	background-color: #f5fbfc;
	flex-direction: column;
	min-width: 1247px;
`;

const ContentApp = styled.div`
	display: flex;
	flex-direction: row;
	height: 90vh;
	position: relative;
	overflow-y: hidden;
`;

export const Overlay = styled.div<{ isVisible: boolean }>`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	z-index: 10;
	display: ${({ isVisible }) => (isVisible ? "block" : "none")};
`;

export default Dashboard;
